import React from "react";

const CancellationAndRefundPolicy = () => (
    <div className="container py-4">
        <h2>Cancellation & Refund Policy</h2>
        <h6 style={{ fontSize: "small", textAlign: 'left' }}>Last updated on 25-07-2025 22:30:00</h6>
        <p style={{ fontSize: "small", textAlign: 'left' }}>
            Thank you for choosing VAKRALABS SERVICES (NAVNATH ATMARAM ADSUL). We are committed to providing high-quality services, and we want to ensure you are satisfied with your experience. Please read our Cancellation & Refund Policy below carefully.
            <ol>
                <li><strong>Cancellation Policy</strong></li>
                <ul>
                    <li>You can cancel your paid service request at any time before it is fully processed or delivered. If you wish to cancel, please contact us as soon as possible. Once we have started processing your request or completed part of the service, cancellations may no longer be possible.</li>
                    <li>To cancel a service, please submit a cancellation request by contacting our customer support team at <a href='mailto:support@vakralabs.com'> support@vakralabs.com </a> or <a href='tel:9423886986'> +91 9423 886 986 </a>. Please provide your order number and relevant details when making the request.</li>
                    <li>For services that have not yet begun processing, you may cancel your order within 24 hours after purchase.</li>
                    <li>For services already in progress or completed, cancellations may not be possible or may incur a cancellation fee.</li>
                </ul>
                <li><strong>Refund Policy</strong>
                    <ul>
                        <li>Refunds are issued only if the service does not meet the description or is not delivered as agreed.</li>
                        <li>Refunds are not granted for dissatisfaction with the final result unless there was an error or oversight on our part. Refunds are eligible under the following conditions:
                            <ul>
                                <li>The service was not delivered as described.</li>
                                <li>The service was not provided within the agreed timeframe. </li>
                                <li>There was a technical error preventing service delivery.</li>
                            </ul>
                        </li>
                        <li>Non-Refundable Services:
                            <ul>
                                <li>Services already delivered or completed, including any content or forms created.</li>
                                <li>If you cancel the service after it has already been started or processed, you will not be entitled to a refund.</li>
                                <li>Requests made after the 24 hours refund window.</li>
                            </ul>
                        </li>
                        <li>To request a refund, please contact our customer support team at  <a href='mailto:support@vakralabs.com'> support@vakralabs.com </a> or <a href='tel:9423886986'> +91 9423 886 986 </a>. Please provide your order number and relevant details when making the request. </li>
                        <li>Refunds will typically be processed within [7-14] business days after approval. Refunds will be issued to the original payment method used during the transaction.</li>
                        <li>If part of the service has been completed, a partial refund may be issued based on the work already performed. This will be evaluated case by case.</li>
                    </ul>
                </li>
                <li> <strong>Exceptions and Disputes</strong>
                    <ul>
                        <li>We may deny a refund request if the issue is due to factors outside of our control, such as incorrect information provided by the customer or failure to meet deadlines on the customer’s side.</li>
                        <li>In case of a dispute, we encourage you to contact our customer service team first. We are committed to resolving issues in a fair and efficient manner.</li>
                    </ul>
                </li>
                <li><strong>Changes to this Policy</strong>
                    <ul><li>We may update this Cancellation & Refund Policy from time to time. When we make changes, we will update the “Last updated on” at the top of the policy and post the new policy on our website. Please review this policy regularly to stay informed of any changes.</li></ul>
                </li>
                <li><strong>Contact Us</strong>
                <ul>
                    <li>If you have any questions about our Cancellation & Refund Policy, please contact our support team at:</li>
                    <p>
                        Vakralabs Services<br />
                    C-902, Bhalchandra Akashvan <br />
                    Punawale, Pimpri-Chinchwad, Pune – 411033<br />
                    Mobile : +91 9423 886 986<br />
                    📧 support@vakralabs.com
                    </p>
                </ul>
                </li>

            </ol>
        </p>
    </div>)


export default CancellationAndRefundPolicy;